import React, { useState } from 'react';
import { Modal, Button, FormField, LoadingIcon } from '@prosolve/common-components-ui'
import useForm from '../hooks/useForm';
import { isValidAssetName, isReservedAssetName } from './assetNameUtils';

export default ({
  currentPath = '',
  onClose,
  onCreate
}) => {
  const formData = useForm({
    requiredFields: ['folderName'],
    initData: { folderName: '' }
  })

  const [isBusy, setIsBusy] = useState(false)
  const [validationError, setValidationError] = useState('')

  const folderName = (formData.values.folderName || '').trim()

  const onSubmit = async () => {
    if (!folderName) return;

    if (!isValidAssetName(folderName)) {
      setValidationError('Folder names must start with a letter or number and can only contain letters, numbers, spaces, dots, underscores, parentheses and hyphens.');
      return;
    }
    if (!currentPath && isReservedAssetName(folderName)) {
      setValidationError(`"${folderName}" is a reserved name and can't be used at the top level.`);
      return;
    }

    try {
      setIsBusy(true)
      await onCreate(currentPath ? `${currentPath}/${folderName}` : folderName)
      onClose()
    } catch (e) {
      setIsBusy(false)
      setValidationError(typeof e === 'string' ? e : 'Unable to create folder')
    }
  }

  const footer = (
    <div style={{
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onSubmit} $colored={true} $disabled={!folderName || isBusy} style={{ position: 'relative' }}>
        {isBusy ? <LoadingIcon /> : 'Create'}
      </Button>
    </div>
  )

  return (
    <Modal title='New Folder' isAutoHeight={true} closeOnOffClick={false} onClose={onClose} footer={footer}>
      <div style={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
        <div style={{ color: '#565656', fontSize: '14px' }}>
          {'Creating in: '}<b>{currentPath ? `Assets/${currentPath}` : 'Assets'}</b>
        </div>
        <FormField
          fieldId='folderName'
          type='text'
          label='Folder name'
          formData={formData}
        />
        {validationError && <div style={{ color: '#ef0c0c', fontSize: '13px' }}>{validationError}</div>}
      </div>
    </Modal>
  )
}
